// extracted by mini-css-extract-plugin
export var drawerContent = "_3a-0";
export var valueBlock = "_3a-1";
export var valueBlockFrom = "_3a-2 _3a-1";
export var valueBlockTo = "_3a-3 _3a-1";